import { Box } from "@material-ui/core";
import { useEffect, useState } from "react";

interface StatusDotProps {
	kumaBaseUrl: string;
	monitorId: number;
	checkInterval: number;
}

export const StatusDot = ({ kumaBaseUrl, monitorId, checkInterval = 600000 }: StatusDotProps) => {
	const [status, setStatus] = useState<"up" | "down" | "pending" | null>(null);

	useEffect(() => {
		const checkStatus = async () => {
			try {
				const response = await fetch(
					`${kumaBaseUrl}/api/badge/${monitorId}/status`,
				);
				const svgText = await response.text();

				if (svgText.includes("Up") || svgText.includes("up")) {
					setStatus("up");
				} else if (svgText.includes("Down") || svgText.includes("down")) {
					setStatus("down");
				} else {
					setStatus("pending");
				}
			} catch (error) {
				setStatus(null);
			}
		};

		checkStatus();
		const interval = setInterval(checkStatus, checkInterval);
		return () => clearInterval(interval);
	}, [kumaBaseUrl, monitorId]);

	const getColor = () => {
		switch (status) {
			case "up": return "green";
			case "down": return "red";
			case "pending": return "orange";
			default: return "gray";
		}
	};

	return (
		<Box
			style={{
				width: 10,
				height: 10,
				borderRadius: "50%",
				backgroundColor: getColor(),
				display: "inline-block",
				marginLeft: 10,
			}}
		/>
	);
};

